import type { ChangeEvent, ReactElement } from 'react';

export type CandidateDecisionPanelProps = {
  reason: string;
  onReasonChange: (reason: string) => void;
  onApprove?: () => void;
  onMerge?: () => void;
  onReject?: () => void;
  onEditHandoff?: () => void;
};

const PRIMARY_BUTTON_CLASS =
  'h-9 px-3 rounded-[var(--r-sm)] text-[13px] font-medium bg-[var(--bg-soft)] text-[var(--ink)] hover:bg-[var(--bg-strong)] disabled:opacity-50 disabled:cursor-not-allowed';
const TEXTAREA_CLASS =
  'resize-none h-24 p-2 text-[12px] rounded-[var(--r-sm)] border border-[var(--rule)] bg-[var(--bg-surface)] text-[var(--ink)] focus:outline-none focus:ring-2 focus:ring-[var(--accent)]';

export function CandidateDecisionPanel({
  reason,
  onReasonChange,
  onApprove,
  onMerge,
  onReject,
  onEditHandoff,
}: CandidateDecisionPanelProps): ReactElement {
  const canReject = reason.trim().length > 0;
  return (
    <aside className="border-l border-[var(--rule)] p-4 flex flex-col gap-3 bg-[var(--bg-surface)]">
      <div className="flex flex-col gap-2">
        <button type="button" className={PRIMARY_BUTTON_CLASS} onClick={onApprove}>
          Approve
        </button>
        <button type="button" className={PRIMARY_BUTTON_CLASS} onClick={onMerge}>
          Merge
        </button>
        <button type="button" className={PRIMARY_BUTTON_CLASS} onClick={onEditHandoff}>
          Edit then approve
        </button>
        <button
          type="button"
          className={PRIMARY_BUTTON_CLASS}
          disabled={!canReject}
          onClick={onReject}
        >
          Reject
        </button>
      </div>
      <label className="flex flex-col gap-1 text-[12px] text-[var(--ink-3)]">
        Reason
        <textarea
          aria-label="Reason"
          value={reason}
          onChange={(event: ChangeEvent<HTMLTextAreaElement>) => onReasonChange(event.target.value)}
          placeholder="Required for reject"
          className={TEXTAREA_CLASS}
        />
      </label>
      <label className="flex items-center gap-2 text-[12px] text-[var(--ink-4)]">
        <input type="checkbox" disabled />
        Notify submitter by email
      </label>
      <label className="flex items-center gap-2 text-[12px] text-[var(--ink-4)]">
        <input type="checkbox" disabled />
        Trust this submitter
      </label>
    </aside>
  );
}
